module.exports = __webpack_public_path__ + "img/1.86e41d7b.png";